<template>
  <div class="pc-parse">
    <div class="pc-parse-wrapper">
      <div class="rowOne">
        <div class="rowOne-one">
          <h1>活跃天数</h1>
          <p>{{ userDetail.active_days ? userDetail.active_days : "- -" }}</p>
        </div>
        <div class="rowOne-two">
          <h1>浏览量</h1>
          <p>{{ userDetail.active_count ? userDetail.active_count : "- -" }}</p>
        </div>
        <div class="rowOne-three">
          <h1>最近访问来源城市</h1>
          <p>{{ userDetail.last_city ? userDetail.last_city : "- -" }}</p>
        </div>
      </div>
      <div class="rowTwo">
        <div class="rowTwo-one">
          <h1>上次访问时间</h1>
          <p>
            {{
              userDetail.last_active_day ? userDetail.last_active_day : "- -"
            }}
          </p>
        </div>
        <!-- <div class="rowTwo-two">
          <h1>{{ data[4].title }}</h1>
          <p>{{ data[4].value ? data[4].value : '- -' }}</p>
        </div> -->
        <!-- <div class="rowTwo-three">
          <h1>{{ data[5].title }}</h1>
          <p>{{ data[5].value ? data[5].value : '- -' }}</p>
        </div> -->
      </div>
      <!-- <div class="rowThree">
        <div class="rowThree-one">
          <h1>{{ data[6].title }}</h1>
          <p>{{ data[6].value ? data[6].value : '- -' }}</p>
        </div>
        <div class="rowThree-two">
          <h1>{{ data[7].title }}</h1>
          <p>{{  data[7].value ? data[7].value : '- -' }}</p>
        </div>
        <div class="rowThree-three"></div>
      </div> -->
    </div>
  </div>
</template>



<script>
export default {
  props: ["userDetail"],
  methods: {
    getDuration(second) {
      var hours = Math.floor(second / 3600) + "";
      var minutes = Math.floor(((second % 86400) % 3600) / 60) + "";
      var seconds = Math.floor(((second % 86400) % 3600) % 60) + "";
      var duration =
        (hours.length == 1 ? "0" : "") +
        hours +
        ":" +
        (minutes.length == 1 ? "0" : "") +
        minutes +
        ":" +
        (seconds.length == 1 ? "0" : "") +
        seconds;
      return duration;
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-parse {
  height: 270px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  display: flex;
  align-items: center;
  justify-content: center;
  .pc-parse-wrapper {
    .rowOne,
    .rowTwo,
    .rowThree {
      display: flex;

      & > div {
        width: 141px;
        height: 72px;
        h1 {
          font-family: $chinese;
          font-size: 14px;
          font-weight: 800;
          color: $mainTitle;
          text-align: center;
          margin-bottom: 10px;
        }
        p {
          font-family: $chinese;
          font-size: 22px;
          color: $lightenYellow;
          white-space: nowrap;
          text-align: center;
        }
      }
       & > div:nth-of-type(2) {
        width: 188px;
      }
    }
    .rowOne {
      margin-bottom: 20px;
    }
    .rowTwo {
      margin-top: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userDetail/UserParse.vue